export class ContractTransformer {

  static transform(obj) {

    let contract = Object.assign({}, { id: obj.id }, obj.attributes);

    return contract;
  }

}



// WEBPACK FOOTER //
// ./src/helpers/contracts/contract.transformer.js